<script setup lang="ts">
import Button from 'primevue/button';

import { useHiddenInputs } from '../composables/useHiddenInputs';
import { useCurrentView } from '../composables/useCurrentView';

const { isHiddenInputs, toggleHiddenInputs } = useHiddenInputs();
const { currentView } = useCurrentView();
</script>

<template>
  <Button severity="secondary" text icon @click="toggleHiddenInputs">
    <i v-if="!isHiddenInputs" class="pi pi-eye"></i>
    <i v-else class="pi pi-eye-slash"></i>
    <span> ({{ currentView?.items.filter((item) => item.is_hidden)?.length }}) </span>
  </Button>
</template>
